// extracted by mini-css-extract-plugin
module.exports =  {"scale":"scale-Toufl","ticks":"ticks-xenvh","label":"label-RekzK","active":"active-v_pyQ"};